<template>
    <transition name="fade" v-if="chartData.length > 0">
        <v-card>
            <v-card-title>
                    <!--<span class="subtitle-1"><v-icon left>mdi-chart-bar</v-icon> Cashier revenue</span>-->
                    <span class="body-2"><v-icon left>mdi-chart-bar</v-icon>{{  chartTitle }}</span>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="card1 = !card1">
                        <v-icon>{{ card1 ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                    </v-btn>
            </v-card-title>
            <v-divider v-show="card1"></v-divider>
            <v-card-text v-show="card1">
                <div id="chart">
                <!--<apexchart type="bar" height="1500" :options="chartOptions" :series="series"></apexchart>-->
                <apexchart :key="chartOptions.chart.height" type="bar" :options="chartOptions" :series="series"></apexchart>
            </div>
            </v-card-text>
        </v-card>
    </transition>
</template>

<script>
import { EventBus } from '@/main.js'
import VueApexCharts from 'vue-apexcharts'

    export default {
        name: 'revenue-cashier',

        components: {
            apexchart: VueApexCharts,
        },

        data: () => ({
            card1: true,
            chartData: [],
            chartTitle: "Cashier revenue",

            series: [{
            data: [/*400, 430, 448, 470, 540, 580, 690, 1100, 1200, 1380, 400, 430, 448, 470, 540, 580, 690, 1100, 1200, 1380, 400, 430, 448, 470, 540, 580, 690, 1100, 1200, 1380, 400, 430, 448, 470, 540, 580, 690, 1100, 1200, 1380*/]
          }],
          chartOptions: {
            chart: {
              type: 'bar',
              height: 350
            },
            colors: ['#00509d'],
            plotOptions: {
              bar: {
                borderRadius: 4,
                horizontal: true,
              }
            },
            dataLabels: {
              enabled: false
            },
            xaxis: {
              categories: [/*'South Korea', 'Canada', 'United Kingdom', 'Netherlands', 'Italy', 'France', 'Japan',
                'United States', 'China', 'Germany','South Korea', 'Canada', 'United Kingdom', 'Netherlands', 'Italy', 'France', 'Japan',
                'United States', 'China', 'Germany','South Korea', 'Canada', 'United Kingdom', 'Netherlands', 'Italy', 'France', 'Japan',
                'United States', 'China', 'Germany'*/
              ],
            },

            tooltip: {
                fixed: {
                    enabled: false,
                },
                x: {
                    show: true,
                },
                y: {
                    title: {
                    formatter: function (seriesName) {
                        return 'Revenue (€):';
                    },
                    },
                },
                marker: {
                    show: false,
                },
            }
          }
        }),

        watch: {
            card1: {
                handler(value) {
                    //window.console.log("Telemetry card1: " + value)
                    this.$store.commit("APP_SETTING", {
                        setting: "cashier_revenue",
                        key: "filter_results_open",
                        value: value
                    })
                },

                //immediate: true
            }
        },

        computed: {
            getChartData() {
                return this.chartData
            }
        },

        methods: {

        },

        created() {
            let vm = this
            vm.card1 = vm.$store.getters.appSettings.cashier_revenue.filter_results_open
        },

        mounted() {
            let vm = this;
            EventBus.$on('widgets-data', (data) => {
            //window.console.log("### RevenueCashier ###");
            //window.console.log(data);

            let payload = data
            if(payload.parameters.startDate !== payload.parameters.endDate) {
              vm.chartTitle = "Cashier revenue (" + payload.parameters.startDate + " - " + payload.parameters.endDate +")"
            } else {
              vm.chartTitle = "Cashier revenue - " + payload.parameters.startDate +  " (" + payload.parameters.startTime + " - " + payload.parameters.endTime +")"
            }

                vm.series = [{
                    data: []
                }]

                /* v1
                vm.chartOptions.xaxis.categories = new Array();

                // DODAJ TO
                const count = data.data.cashier_revenue.length;

                vm.chartOptions = {
                    ...vm.chartOptions,
                    chart: {
                        ...vm.chartOptions.chart,
                        height: count < 5
                            ? 300
                            : Math.min(2000, 80 + count * 36)
                    }
                };

                let seriesData = []
                let c = 0;
                data.data.cashier_revenue.forEach(item => {
                    if(c < 200) {
                        vm.chartOptions.xaxis.categories.push(item.name)
                        seriesData.push(item.value)
                    }

                    c++
                })
                */

                // v2
                const count = data.data.cashier_revenue.length;
                const height = count < 5
                    ? 300
                    : Math.min(2000, 80 + count * 36);

                const names = [];
                const seriesData = [];

                data.data.cashier_revenue.slice(0, 200).forEach(item => {
                    names.push(String(item.name || ''));
                    seriesData.push(Number(item.value || 0));
                });

                vm.chartOptions = {
                    ...vm.chartOptions,
                    xaxis: {
                        ...(vm.chartOptions.xaxis || {}),
                        categories: names,
                    },
                    chart: {
                        ...(vm.chartOptions.chart || {}),
                        height,
                    },
                };


                //window.console.log(seriesData)
                //window.console.log(vm.chartOptions.xaxis.categories)

                vm.series = [{
                    data: seriesData
                }]

                vm.chartData = seriesData;

                vm.$nextTick(() => {
                    vm.chartOptions = {
                        ...vm.chartOptions,
                        xaxis: {
                            ...(vm.chartOptions.xaxis || {}),
                            categories: names,
                        },
                        chart: {
                            ...(vm.chartOptions.chart || {}),
                            height,
                        },
                    };

                    vm.series = [{
                        data: seriesData
                    }];
                });
            })
        },

        beforeDestroy() {
            EventBus.$off('widgets-data'); 
        }
    }
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition-property: opacity;
        transition-duration: .25s;
    }

    .fade-enter-active {
        transition-delay: .25s;
    }

    .fade-enter, .fade-leave-active {
        opacity: 0
    }
</style>

